export const ADD_DOCTORS_FORM_ID = 'add-doctors';
